import { createTheme, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import __t from '../../lib/traduzioni';
import { Controller } from 'react-hook-form';
import useBSSController from '../../hooks/useBSSController';
import useBSSLogger from '../../hooks/useBSSLogger';

const {logger} = useBSSLogger();

const BSSSwitch = ({
    name, 
    label = name,
    methods,
    dependsOn = null,
    ControllerProps = {},
    FormControlLabelProps = {},
    SwitchProps = {},
}) => {
    
    const {classes, control, dipendenze, disabilitaByDep, defaultValue} = useBSSController({name, defaultValue: false, dependsOn, methods})

    return (
        <>
            <Controller
                name={name} 
                control={control}     
                defaultValue={defaultValue}                                           
                render={({field, fieldState}) => {                    
                    
                    return (
                    <>  
                        <FormControlLabel
                            disabled={disabilitaByDep}
                            variant="outlined" 
                            size="small"                                                          
                            label={__t(label)}
                            control={
                                <Switch 
                                    {...field}
                                    checked={field.value}
                                    value={field.value}   
                                    inputRef={field.ref}                                     
                                    {...SwitchProps}
                                    onChange={
                                        e => {
                                            logger.debug("switch cambio valore", name, e.target.checked)
                                            const value = e?.target?.checked ?? false;
                                            field.onChange(value)
                                            if(SwitchProps.afterChange){
                                                SwitchProps.afterChange(value)
                                            }
                                        }
                                    }
                                />
                            }  
                            {...FormControlLabelProps}                                                                                                         
                        />
                    </>
                )}}
                {...ControllerProps}        
            />            
        </>
    )
}

export default BSSSwitch; 